module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/global-filtering/global-filtering.component.css
// module id = ./src/app/examples/global-filtering/global-filtering.component.css
// module chunks = main